import React, { FC } from 'react';
import Modal from 'components/shared/Modal';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { createPagePostRequirement } from 'app/modules/pages/api/createPagePostRequirement';
import { useToast } from 'app/hooks/useToast';
import { PageData } from 'types/Page';
import NewPostRequirementModalForm from 'app/components/modals/newPostRequirement/NewPostRequirementModalForm';
import { colors, Icon, Tooltip } from '@kontentino/ui';
import { faCog } from '@fortawesome/pro-regular-svg-icons/faCog';
import Link from 'components/shared/Link';

type Props = {
  page: Pick<PageData, 'type' | 'id'>;
  open: boolean;
  onHide: () => void;
};

const NewPostRequirementModal: FC<Props> = ({ page, open, onHide }) => {
  const { t } = useTranslation();
  const toast = useToast();

  const { mutate, isLoading } = useMutation(createPagePostRequirement, {
    onSuccess() {
      toast(t('postRequirementCreated'));
      onHide();
    },
    onError() {
      toast(t('somethingWentWrong'), 'error');
    },
  });

  return (
    <Modal
      focusTrapped={false}
      isLoading={isLoading}
      open={open}
      onClose={onHide}
    >
      <Modal.Header
        title={
          <>
            {t('newPostChecklistItem')}
            <Tooltip content={t('manageChecklist')}>
              <Link
                to={`/projects/pages/page:${page.id}/type:my/property:post-requirements`}
                className="tw-ml-2"
              >
                <Icon icon={faCog} color={colors.gray80} />
              </Link>
            </Tooltip>
          </>
        }
      />
      {page.type && (
        <NewPostRequirementModalForm
          onSubmit={(form) =>
            mutate({
              name: form.name,
              postType: form.postType?.value.toString() || '',
              isGlobal: form.isGlobal,
              pageId: page.id,
            })
          }
          onClose={onHide}
          pageType={page.type}
        />
      )}
    </Modal>
  );
};

export default NewPostRequirementModal;
